module.exports = "pegasus/assets/blocks/header-5-tech.png";